import { IconButton, Stack, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { CloseIcon } from "src/foundations/icons";

export interface DrawerHeaderProps {
    closeDrawerOnClick: () => void;
    title?: string;
    mobile: boolean;
}

export const DrawerHeader = ({ closeDrawerOnClick, title, mobile }: DrawerHeaderProps) => {
    return (
        <Box style={{ width: "100%" }}>
            {mobile ? <MobileHeader title={title} /> : <DesktopHeader title={title} closeDrawerOnClick={closeDrawerOnClick} />}
        </Box>
    );
};

const DesktopHeader = ({ title, closeDrawerOnClick }: { title?: string; closeDrawerOnClick: () => void }) => (
    <Stack display={"flex"} direction={"row"} alignItems={"center"}>
        <Box sx={{ flexGrow: 1, width: "0" }}>
            {title && (
                <Typography
                    data-testid={"desktop-title"}
                    variant="h4"
                    sx={{
                        display: "-webkit-box",
                        overflow: "hidden",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 1,
                    }}
                >
                    {title}
                </Typography>
            )}
        </Box>
        <DesktopCloseBtn closeDrawerOnClick={closeDrawerOnClick} />
    </Stack>
);

const MobileHeader = ({ title }: { title?: string }) => (
    <Stack>
        {title && (
            <Typography
                data-testid={"mobile-title"}
                variant="h4"
                sx={{
                    display: "-webkit-box",
                    overflow: "hidden",
                    WebkitBoxOrient: "vertical",
                    WebkitLineClamp: 1,
                }}
            >
                {title}
            </Typography>
        )}
    </Stack>
);

const DesktopCloseBtn = ({ closeDrawerOnClick }: MobileCloseBtnProps) => (
    <Box>
        <IconButton
            data-testid={"close-btn-id"}
            size="small"
            aria-label="back"
            aria-controls="header-system-details"
            aria-haspopup="true"
            sx={{ margin: "0 0 0 1rem" }}
            onClick={closeDrawerOnClick}
        >
            <CloseIcon />
        </IconButton>
    </Box>
);

export interface MobileCloseBtnProps {
    closeDrawerOnClick: () => void;
}
export const MobileCloseBtn = ({ closeDrawerOnClick }: MobileCloseBtnProps) => (
    <Box
        sx={{
            display: "flex",
            justifyContent: "right",
            margin: "0.4rem 0",
        }}
    >
        <IconButton
            sx={{
                "&:hover": {
                    background: "none",
                },
                padding: "0",
            }}
            data-testid={"close-btn-id"}
            size="medium"
            aria-label="back"
            aria-controls="header-system-details"
            aria-haspopup="true"
            onClick={closeDrawerOnClick}
        >
            <CloseIcon />
        </IconButton>
    </Box>
);
